import { GuestUserStats } from '../../types/dashboard';

export enum GuestUserCategoryBreakdown {
    Status = 'status',
    Profile = 'profile',
}

export type GuestUserCategoryPoint = {
    label: string;
    count: number;
};

export function statusBreakdownToPoints(
    data?: GuestUserStats,
): GuestUserCategoryPoint[] {
    return [
        {
            label: 'Active',
            count: data?.statusBreakdown?.active ?? 0,
        },
        {
            label: 'Disabled',
            count: data?.statusBreakdown?.disabled ?? 0,
        },
    ];
}

export function profileBreakdownToPoints(
    data?: GuestUserStats,
): GuestUserCategoryPoint[] {
    return [
        {
            label: 'Complete',
            count: data?.profileSetupBreakdown?.withProfilePicture ?? 0,
        },
        {
            label: 'Incomplete',
            count: data?.profileSetupBreakdown?.withoutProfilePicture ?? 0,
        },
    ];
}

export function guestUserBreakdownToPoints(
    data: GuestUserStats | undefined,
    breakdown: GuestUserCategoryBreakdown,
): GuestUserCategoryPoint[] {
    return breakdown === GuestUserCategoryBreakdown.Status
        ? statusBreakdownToPoints(data)
        : profileBreakdownToPoints(data);
}

export function guestUserCategoryLabel(
    breakdown: GuestUserCategoryBreakdown,
): string {
    return breakdown === GuestUserCategoryBreakdown.Status
        ? 'Status'
        : 'Profile';
}

export function formatStatusBreakdown(data?: GuestUserStats): string {
    const active = data?.statusBreakdown?.active ?? 0;
    const disabled = data?.statusBreakdown?.disabled ?? 0;
    return `${active.toLocaleString()} active · ${disabled.toLocaleString()} disabled`;
}

export function formatProfileBreakdown(data?: GuestUserStats): string {
    const complete = data?.profileSetupBreakdown?.withProfilePicture ?? 0;
    const incomplete = data?.profileSetupBreakdown?.withoutProfilePicture ?? 0;
    return `${complete.toLocaleString()} complete · ${incomplete.toLocaleString()} incomplete`;
}
